import { useEffect } from 'react';
import { Tile } from 'festo-react-ui-kit';

import Item from './Item/Item';
import WorkloadContainer from './WorkloadContainer/WorkloadContainer';
import PropertiesContainer from './PropertiesContainer/PropertiesContainer';
import AddToBasket from './AddToBasket/AddToBasket';

import { ShockAbsorberSolution } from '../../../interfaces';
import { econdaClickEvent, econdaEnhancedTracking } from '../../../Econda';
import { RequestHandler } from '../../../app/RequestHandler';
import './SolutionTile.scss';
import { PricingItemResponse } from '../../../features/pricing/api';
import { useLocation } from 'react-router';

interface SolutionTileProps {
  shockAbsorber: ShockAbsorberSolution;
  articleCodes: string[];
  price: PricingItemResponse | null;
}

export default function SolutionTile({ shockAbsorber, articleCodes, price }: SolutionTileProps): JSX.Element {
  const { applicationType } = new RequestHandler();
  const { pathname } = useLocation();

  useEffect(() => {
    econdaEnhancedTracking(`${shockAbsorber.partNumber}`, articleCodes);
  }, [articleCodes, shockAbsorber.partNumber]);

  return (
    <>
      <Tile main className="ems-solution-tile fwe-mb-3">
        <div className="solutiontile-container">
          <Item
            key={`${shockAbsorber.orderCode}-${shockAbsorber.partNumber}`}
            orderCode={shockAbsorber.orderCode}
            partNumber={shockAbsorber.partNumber}
            img={shockAbsorber.image}
            onClick={() =>
              econdaClickEvent(pathname, 'cta buttons', 'product link', `shock absorber | ${shockAbsorber.orderCode}`)
            }
          />
          <div className="item-workload-container">
            <div className="workload-container">
              <WorkloadContainer
                utilizationPerStroke={shockAbsorber.utilizationPerStroke}
                utilizationPerHour={shockAbsorber.utilizationPerHour}
              />
            </div>
            <div className="properties-container">
              <PropertiesContainer
                lengthAtEnd={shockAbsorber.bodyLength}
                speed={shockAbsorber.maxImpactSpeed}
                thread={shockAbsorber.thread}
              />
            </div>
          </div>
        </div>
      </Tile>
      {applicationType !== 'standalone' ? <AddToBasket product={shockAbsorber} price={price} /> : null}
    </>
  );
}
